module.exports = __webpack_public_path__ + "static/browser-mockup-container-e4d47982863a3113ad827589c78fa4e8.webp";